// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2137":"2725dd987c1b10fb","2338":"b31e9202b0cc5c7e","2964":"43abf21bbf5de05b","3486":"af4e0d13575f8bc1","3744":"1da87903329ce29f","5277":"19085b5341151105","6265":"1ed9f90202abf9f9","6555":"96fd6de3004cc1fc","8684":"50b38a6a0579613b"}[chunkId] + ".js";
};